import { CSSProperties } from 'react'

import styled from '@emotion/styled'

import spacing from '../../theme/spacing'

const isSpacing = (space: keyof typeof spacing | string): space is keyof typeof spacing =>
  (space as keyof typeof spacing) in spacing

const parseGap = (gap: string) => (isSpacing(gap) ? spacing[gap] : gap)

export const Flex = styled.div<{
  alignItems?: CSSProperties['alignItems']
  alignSelf?: CSSProperties['alignSelf']
  flexDirection?: CSSProperties['flexDirection']
  flexWrap?: CSSProperties['flexWrap']
  gap?: string
  justifyContent?: CSSProperties['justifyContent']
  flexBasis?: CSSProperties['flexBasis']
  flexShrink?: CSSProperties['flexShrink']
  flexGrow?: CSSProperties['flexGrow']
  fullWidth?: boolean
}>`
  ${({ alignItems }) => alignItems != null && `align-items: ${alignItems};`}
  ${({ alignSelf }) => alignSelf != null && `align-self: ${alignSelf};`}
  ${({ flexDirection }) => flexDirection != null && `flex-direction: ${flexDirection};`}
  ${({ flexWrap }) => flexWrap != null && `flex-wrap: ${flexWrap};`}
  ${({ gap }) => gap != null && `gap: ${parseGap(gap)};`}
  ${({ justifyContent }) => justifyContent != null && `justify-content: ${justifyContent};`}
  ${({ flexBasis }) => flexBasis != null && `flex-basis: ${flexBasis};`}
  ${({ flexShrink }) => flexShrink != null && `flex-shrink: ${flexShrink};`}
  ${({ flexGrow }) => flexGrow != null && `flex-grow: ${flexGrow};`}
  ${({ fullWidth }) => fullWidth && `width: 100%;`}
  display: flex;
`

export const FullWidthFlex = styled(Flex)`
  width: 100%;
`

export const FlexGrow = styled.div`
  flex: 1;
`

export const FlexNone = styled.div`
  flex: none;
`
